// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"846e237f","257":"f9915ca4","626":"c8708682"}[chunkId] + ".chunk.css";
};